/**
 * Подбор контейнера для MediaRecorder (docs/RECORDING.md, «Форматы»).
 * Порядок — по убыванию предпочтения: opus в webm, затем mp4 для Safari.
 */
const CANDIDATES: readonly string[] = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/ogg;codecs=opus',
  'audio/mp4;codecs=mp4a.40.2',
  'audio/mp4',
]

export type MimeChoice = { mimeType: string; extension: string }

export function pickMimeType(): MimeChoice | null {
  if (typeof MediaRecorder === 'undefined') return null
  for (const candidate of CANDIDATES) {
    if (MediaRecorder.isTypeSupported(candidate)) {
      return { mimeType: candidate, extension: extensionFor(candidate) }
    }
  }
  // Браузер поддерживает MediaRecorder, но ни один из кандидатов не подошёл —
  // отдаём пустую строку, тогда MediaRecorder выберет формат по умолчанию.
  return { mimeType: '', extension: 'webm' }
}

export function extensionFor(mimeType: string): string {
  if (mimeType.includes('webm')) return 'webm'
  if (mimeType.includes('ogg')) return 'ogg'
  if (mimeType.includes('mp4')) return 'm4a'
  if (mimeType.includes('wav')) return 'wav'
  return 'webm'
}

export function isRecordingSupported(): boolean {
  return (
    typeof MediaRecorder !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    typeof navigator.mediaDevices?.getUserMedia === 'function'
  )
}
